angular.module('rightPaneModule', ['charts', 'core', 'ngMessages'])
    .controller('RightPaneController', [
      '$scope',
      '$timeout',
      'edxCustomerSettingsService',
      'configuration',
      'authentication',
      'dblUserAgent',
      'assignMode',
      function(
        $scope,
        $timeout,
        edxCustomerSettingsService,
        $configuration,
        $authentication,
        dblUserAgent,
        assignMode
      ) {

        $scope.assignModeService = assignMode;

        $scope.onScroll = function (scrollTop, scrollHeight) {
            var threshold = 5;
            var scrolledToBottom = (scrollHeight - scrollTop) <= threshold;

            if( scrolledToBottom ) {
                $scope.$broadcast('rightPaneScrollBottom');
            }

            $scope.$broadcast('rightPaneScroll', {
                scrollTop: scrollTop,
                scrollHeight: scrollHeight
            });
        };
    }]);
